module.exports = __webpack_public_path__ + "img/forest.52a96b35.jpg";